import { styled } from "styled-components";

export const AppStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 120px;
  background: white;
  justify-content: center;
  align-items: center;
  font-family: "Inter";
  padding-bottom: 30px;

  @media (max-width: 1300px) {
    gap: 80px;
  }
`;

AppStyled.ContentContainer = styled.div`
  display: flex;
  gap: 72px;

  @media (max-width: 1300px) {
    gap: 80px;
    max-width: 370px;
    flex-direction: column;
  }
`;